import { NormalizedSchema, Schema, normalize as rawNormalize } from 'normalizr'

import type { TApiState } from '@hozana/api/types'

export const normalize = rawNormalize as <T = any, R = any>(
  data: any,
  schema: Schema<T>,
) => NormalizedSchema<TApiState['entities'], R>
